import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import { createStructuredSelector } from 'reselect';
// mui
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
// icons-material
import LogoutIcon from '@mui/icons-material/Logout';
import FileUploadIcon from '@mui/icons-material/Backup';
// constants
import * as C from '../../../constants';
// utilities
import { windowLocationReload, removeAuthTokenFromStorage } from '../../../utilities';
// components
import Icon from '../../icons';
import { ModalComponent } from '../../modal';
import { modalRoutine } from '../../modal/routines';
import ReportFormatPanel from '../../report-format-panel';
import { makeSelectIsModalOpened } from '../../modal/selectors';
// forms
import { UploadFileForm } from '../../../forms';
// component header
import { makeSelectFileUploadData } from './selectors';
import FileUploadProgress from './components/file-upload-progress';
import { headerRoutine, headerFileUploadStatusData } from './routines';
// feature auth
import { loginRoutine } from '../../../features/auth/routines';
//////////////////////////////////////////////////

const Header = ({
  opened,
  logout,
  fileData,
  openModal,
  closeModal,
  submitAction,
  checkFileData,
}) => {
  const dispatch = useDispatch();

  const { t } = useTranslation();

  const navigate = useNavigate();

  const handleLogout = () => {
    navigate(C.ROUTE_PATH_LOGIN);

    logout();

    removeAuthTokenFromStorage();

    windowLocationReload();
  };

  return (
    <Box
      px={4}
      width='100%'
      height='60px'
      display='flex'
      alignItems='center'
      justifyContent='space-between'
      data-testid='testid-Header-wrapper'
      backgroundColor={t => t.colors.middleGrey}
    >
      <Box display='flex' alignItems='center'>
        <Icon mr={30} name='logo' height='40px' width='205px' />
        <Typography fontSize={20} color={t => t.colors.lightBlack}>
          {t('labels.marketingListUi')}
        </Typography>
      </Box>
      <Box display='flex' alignItems='center'>
        <FileUploadProgress fileData={fileData} checkFileData={checkFileData} />
        <IconButton
          sx={{ ml: '20px' }}
          onClick={openModal}
          title={t('actions.uploadFile')}
          data-testid='testid-Header-uploadFile-icon'
        >
          <FileUploadIcon cursor='pointer' sx={{ fontSize: '35px', color: t => t.colors.darkGreen }} />
        </IconButton>
      </Box>
      <Box display='flex' alignItems='center'>
        <ReportFormatPanel />
        <IconButton
          sx={{ ml: '40px' }}
          onClick={handleLogout}
          title={t('labels.logOut')}
          data-testid='testid-Header-handleLogout-link'
        >
          <LogoutIcon cursor='pointer' sx={{ fontSize: '28px', color: t => t.colors.black }} />
        </IconButton>
      </Box>
      <ModalComponent
        opened={opened}
        handleClose={closeModal}
        modalTitle={t('actions.uploadFile')}
        additionalStyles={{ maxWidth: '450px' }}
        component={(
          <UploadFileForm
            isLoading={false}
            submitText='upload'
            dispatch={dispatch}
            cancelAction={closeModal}
            submitAction={submitAction}
            title={t('actions.uploadFile')}
          />
        )}
      />
    </Box>
  );
};

const mapStateToProps = state => createStructuredSelector({
  opened: makeSelectIsModalOpened(state),
  fileData: makeSelectFileUploadData(state),
});

const mapDispatchToProps = dispatch => ({
  openModal: () => dispatch(modalRoutine(true)),
  logout: () => dispatch(loginRoutine.failure()),
  closeModal: () => dispatch(modalRoutine(false)),
  checkFileData: () => dispatch(headerFileUploadStatusData()),
  submitAction: values => dispatch(headerRoutine.upload(values)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
